import React from 'react';

const spinnerKeyframes = `
  @keyframes spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }
  @keyframes progress { 0% { width: 0%; margin-left: 0%; } 50% { width: 100%; margin-left: 0%; } 100% { width: 0%; margin-left: 100%; } }
`;

const LoadingSpinner = ({ label = 'Loading' }) => (
  <>
    <style>{spinnerKeyframes}</style>
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-8">
      <div className="relative">
        <div style={{ border: '4px solid rgba(18, 76, 114, 0.1)', borderLeftColor: 'rgb(18, 76, 114)', borderRadius: '50%', width: '40px', height: '40px', animation: 'spin 1s linear infinite' }}></div>
        <div className="absolute inset-0 rounded-full animate-pulse" style={{ backgroundColor: 'rgba(18, 76, 114, 0.1)', transform: 'scale(1.5)', zIndex: -1 }}></div>
      </div>
      <div className="mt-6 text-center">
        <h3 className="text-lg font-semibold mb-2" style={{ color: 'rgb(18, 76, 114)' }}>{label}</h3>
        <p className="text-sm" style={{ color: 'rgba(18, 76, 114, 0.7)' }}>Please wait while we fetch the latest data...</p>
        <div className="mt-4 w-48 h-1 bg-gray-200 rounded-full overflow-hidden mx-auto">
          <div className="h-full rounded-full" style={{ backgroundColor: 'rgb(18, 76, 114)', animation: 'progress 1.5s ease-in-out infinite' }}></div>
        </div>
      </div>
    </div>
  </>
);

export default LoadingSpinner;
